import { Box, Typography } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Chip from "@mui/material/Chip";
import MenuList from "@mui/material/MenuList";
import { hmLightTheme } from "../themes/hmTheme";
import CustomMenuItemLink from "../unit/CustomMenuItemLink";
import HmSubHeaderTitle from "../unit/HmSubHeaderTitle";

const AppMenuTitle = ({ ...props }) => {
  const type = props.type;
  const appCounts = props.count;
  let chipBgColor = "white";
  let textColor = "#000";
  let showTitle = type;
  if (
    showTitle == "campaignsToApplications" ||
    showTitle == "couponcodesToApplications"
  ) {
    showTitle = "Applications Submitted";
  }
  return (
    <Box sx={{ width: "100%" }}>
      {showTitle}
      <Chip
        component="span"
        label={appCounts}
        size="small"
        sx={{
          ml: 1,
          float: "right",
          fontFamily: hmLightTheme?.palette?.numberFontFamily,
          backgroundColor: chipBgColor,
          color: textColor,
        }}
      />
    </Box>
  );
};

const CampaignsListAside = ({ ...props }) => {
  const selected = props.selected;
  const totalData = props.totalData;
  return (
    <>
      <HmSubHeaderTitle
        title={"Marketing"}
        sx={{
          display: "block",
          position: "absolute",
          top: "70px",
          left: "75px",
        }}
      />
      <Card className="hm-list-aside">
        <CardContent sx={{ pt: 0 }}>
          <MenuList component="div" id="list-campaigns-couponcode-menus">
            <Typography
              variant="h3"
              className="hm-subtitle"
              sx={{
                pl: 0,
                pt: 1,
                pb: 1,
                mb: 1,
              }}
            >
              Landing Pages
            </Typography>
            <CustomMenuItemLink
              to="/campaigns"
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle type="Pages" count={totalData?.campaign} />
              }
              selected={selected === "campaigns"}
              tooltipProps={{ title: "Pages", children: <></> }}
            />
            <CustomMenuItemLink
              to="/campaignsToApplications"
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle
                  type="campaignsToApplications"
                  count={totalData?.campaignapps}
                />
              }
              selected={selected === "campaignsToApplications"}
              tooltipProps={{
                title: "Applications Submitted",
                children: <></>,
              }}
            />
            <hr />
            <Typography
              variant="h3"
              className="hm-subtitle"
              sx={{
                pl: 0,
                pt: 1,
                pb: 1,
                mb: 1,
              }}
            >
              Coupon Codes
            </Typography>
            <CustomMenuItemLink
              to="/couponcodes"
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle type="Codes" count={totalData?.couponcode} />
              }
              selected={selected === "couponcodes"}
              tooltipProps={{ title: "Codes", children: <></> }}
            />
            <CustomMenuItemLink
              to="/couponcodesToApplications"
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle
                  type="couponcodesToApplications"
                  count={totalData?.couponcodeapps}
                />
              }
              selected={selected === "couponcodesToApplications"}
              tooltipProps={{
                title: "Applications Submitted",
                children: <></>,
              }}
            />
          </MenuList>
        </CardContent>
      </Card>
    </>
  );
};

export default CampaignsListAside;
